const STORAGE_KEY = 'tabys-balance-v1';

export function getBalance() {
  try {
    const value = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    return Number.isFinite(value) && value >= 0 ? value : 0;
  } catch {
    return 0;
  }
}

export function addBalance(amount) {
  const gain = Math.max(0, Math.round(amount));
  const next = getBalance() + gain;
  try {
    localStorage.setItem(STORAGE_KEY, String(next));
  } catch {
    // storage unavailable; balance just won't persist
  }
  window.dispatchEvent(new CustomEvent('balance-change', { detail: next }));
  return next;
}

// 11111 -> "11 111"
export function formatBalance(value) {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
